import toast from "react-hot-toast";
import { supabase } from "../service/supabase";
import useSignIn from "react-auth-kit/hooks/useSignIn";
import useSignOut from "react-auth-kit/hooks/useSignOut";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

export const useAuthProvider = () => {
  const signInAuthKit = useSignIn();
  const signOutAuthKit = useSignOut();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);
  useEffect(() => {
    const fetchSession = async () => {
      try {
        const {
          data: { session },
          error,
        } = await supabase.auth.getSession();
        if (error) throw error;
        if (session) {
          signInAuthKit({
            auth: {
              token: session.access_token,
              type: session.token_type,
            },
            userState: session.user,
          });
          setUser(session.user);
          setToken(session.access_token);
        }
      } catch (error) {
        console.error("Error fetching session:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSession();

    const { data: authListener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (event === "SIGNED_IN" && session) {
          signInAuthKit({
            auth: {
              token: session.access_token,
              type: session.token_type,
            },
            userState: session.user,
          });
          setUser(session.user);
        } else if (event === "SIGNED_OUT") {
          signOutAuthKit();
          setUser(null);
          setToken(null);
          toast.success("Signed out successfully!");
        }
      }
    );

    return () => {
      authListener?.subscription.unsubscribe();
    };
  }, [signInAuthKit, signOutAuthKit]);

  const signIn = async (email, password) => {
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });
      if (error) throw error;
      if (data.session) {
        signInAuthKit({
          auth: {
            token: data.session.access_token,
            type: data.session.token_type,
          },
          userState: data.session.user,
        });
        setUser(data.session.user);
        console.log(data, "data");
        setToken(data.session.access_token);
        navigate("/");
        toast.success("Welcome back.");
        return data.session.user;
      }
      return null;
    } catch (error) {
      toast.error("Sign in error, please try again!");
      console.error("Sign In Error:", error.message);
      return null;
    }
  };

  const signOut = async () => {
    try {
      await supabase.auth.signOut();
      signOutAuthKit();
      setUser(null);
      setToken(null);
    } catch (error) {
      toast.error("Sign out error, please try again!");
      console.error("Sign Out Error:", error.message);
    }
  };

  return {
    user,
    token,
    loading,
    signIn,
    signOut,
  };
};
